import { makeStyles } from 'tss-react/mui';
import { GLOBAL_SCROLLBAR_WIDTH } from '../../../../../themes/v2/V2GlobalStyles';
import { AMOUNTS_CONVERSION_GAP_SPACING } from '../../orderTargets.constants';
import { getConversionColumnStyle } from '../../orderTargets.styles';
import { OrderTargetBreakdownListContext } from '../../orderTargets.types';

export const ROW_PITCH = 26;
export const VISIBLE_ROWS = 10;
const CONTENT_INLINE_SPACING = 1.5;
const SCROLLBAR_OFFSET_SPACING = 0.5;

const useOrderTargetBreakdownListStyles = makeStyles<OrderTargetBreakdownListContext>()(
  (theme, { amountsMinChars }) => ({
    scroller: {
      scrollbarGutter: 'stable',
      marginRight: theme.spacing(SCROLLBAR_OFFSET_SPACING),
      '&:focus-visible': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`,
      },
    },
    grid: {
      paddingLeft: theme.spacing(CONTENT_INLINE_SPACING),
      paddingRight: `calc(${theme.spacing(CONTENT_INLINE_SPACING - SCROLLBAR_OFFSET_SPACING)} - ${GLOBAL_SCROLLBAR_WIDTH}px)`,
      display: 'grid',
      gridTemplateColumns: `minmax(0, 1fr) minmax(${amountsMinChars}ch, auto) auto`,
      gridAutoRows: ROW_PITCH,
      columnGap: theme.spacing(AMOUNTS_CONVERSION_GAP_SPACING),
    },
    row: {
      display: 'grid',
      gridTemplateColumns: 'subgrid',
      gridColumn: '1 / -1',
      alignItems: 'center',
    },
    amounts: {
      justifySelf: 'end',
      whiteSpace: 'nowrap',
      fontVariantNumeric: 'tabular-nums',
      textBox: 'trim-both cap alphabetic',
    },
    conversion: getConversionColumnStyle(theme),
    loading: {
      padding: theme.spacing(0, CONTENT_INLINE_SPACING),
    },
  }),
);

export default useOrderTargetBreakdownListStyles;
